import ModuleBase from '../module-base/index.js';
import ShowMoreControl from './show-more/index.js';

class DataCollection extends ModuleBase {

  constructor(configuration, page) {

    super(configuration, page);

    this.pageId = this.page.configuration.pageId;
    this.dataCollectionInterfaces = null;
    this.showMoreControl = null;

    this.layout = null;
    this.hasMore = false;
    this.pageSize = 0;
    this.loadedCount = 0;

    this.loadMore = this.loadMore.bind(this);

  }

  async setupServerInterfaces() {

    const DataCollectionInterfaces = (await import('../api-interface/data-collection/index.js')).default;

    const apiInterface = await this.page.getDependency('api-interface');

    this.dataCollectionInterfaces = new DataCollectionInterfaces(apiInterface.basePath, apiInterface.apiClient);

  }

  async loadMore() {

    this.showMoreControl.startLoading();

    let result;

    try {
      result = await this.dataCollectionInterfaces.getRowsHTML(this.pageId, this.configuration.collectionId, this.configuration.filterId, this.loadedCount, this.pageSize);
    } catch (error) {
      this.showMoreControl.showError();
      return;
    }

    if (result.count > 0) {
      this.layout.insertAdjacentHTML('beforeend', result.html);
      this.loadedCount = this.loadedCount + result.count;
    }

    if (result.hasMore === true) {
      this.showMoreControl.stopLoading();
    } else {
      this.showMoreControl.remove();
    }

  }

  async initialize() {

    this.layout = document.getElementById(`dc-${this.configuration.id}`);

    if (this.layout === null) {
      return;
    }

    this.hasMore = this.layout.getAttribute('data-has-more') === 'true';
    this.pageSize = Number(this.layout.getAttribute('data-page-size'));
    this.loadedCount = Number(this.layout.getAttribute('data-loaded-count'));

    if (this.hasMore === false) {
      return;
    }

    await this.setupServerInterfaces();

    this.showMoreControl = new ShowMoreControl(this.loadMore);
    this.layout.insertAdjacentElement('afterend', this.showMoreControl.el);

  }

}

export default DataCollection;
